import { useSuspenseQuery } from '@apollo/client';
import React from 'react';
import { Outlet } from 'react-router-dom';

import { graphql } from '@eluve/graphql.tada';
import { useReviewHasuraContext } from '@eluve/session-helpers';
import { TabNav } from '@eluve/smart-blocks';

import { AppointmentAnnotationTools } from './AppointmentAnnotationTools';
import {
  draftContentFragment,
  ehrDiffContentFragment,
  summaryContentFragment,
} from './AppointmentArtifacts';
import {
  appointmentAnnotationsFragment,
  appointmentLowQualityFactorsFragment,
  appointmentReviewLinksFragment,
  appointmentTagOptionsFragment,
  appointmentTagsFragment,
} from './operations';
import { reviewAppointmentDetailsTabNav } from './routes';
import { useAppointmentParams } from './useAppointmentParams';

export interface ReviewAppointmentLayoutProps {
  showTools?: boolean;
}

const appointmentArtifactsQuery = graphql(
  `
    query appointmentArtifacts(
      $tenantId: uuid!
      $appointmentId: uuid!
      $includeAnnotations: Boolean!
    ) {
      appointmentsByPk(tenantId: $tenantId, id: $appointmentId) {
        ...SummaryContent
        ...DraftContent
        ...EhrDiffContent
        ...Annotations @include(if: $includeAnnotations)
        ...LowQualityFactors @include(if: $includeAnnotations)
        ...ReviewLinks @include(if: $includeAnnotations)
        ...Tags @include(if: $includeAnnotations)
      }
      ...TagOptions @include(if: $includeAnnotations)
    }
  `,
  [
    summaryContentFragment,
    draftContentFragment,
    ehrDiffContentFragment,
    appointmentAnnotationsFragment,
    appointmentLowQualityFactorsFragment,
    appointmentReviewLinksFragment,
    appointmentTagOptionsFragment,
    appointmentTagsFragment,
  ],
);

export const ReviewAppointmentLayout: React.FC<
  ReviewAppointmentLayoutProps
> = ({ showTools = false }) => {
  const { tenantId, appointmentId } = useAppointmentParams();
  const context = useReviewHasuraContext();

  useSuspenseQuery(appointmentArtifactsQuery, {
    context,
    variables: { tenantId, appointmentId, includeAnnotations: showTools },
  });
  return (
    <div>
      {showTools && <AppointmentAnnotationTools />}

      <div>
        <TabNav tabs={reviewAppointmentDetailsTabNav} />
      </div>
      <Outlet />
    </div>
  );
};
